import { siteName } from '@/mocks/homeData';

const footerLinks = [
  {
    title: '热门分类',
    links: ['古装剧场', '悬疑探案', '都市情感', '科幻奇幻', '日韩专区'],
  },
  {
    title: '快速导航',
    links: ['热度榜单', '更新动态', '常见问题', '平台特色', '联系我们'],
  },
  {
    title: '关于我们',
    links: ['平台介绍', '使用帮助', '内容来源', '版权声明', '加入我们'],
  },
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-heading text-background-50 whitespace-nowrap">
                {siteName}
              </span>
            </div>
            <p className="text-xs md:text-sm text-foreground-300 leading-relaxed mb-4">
              聚合西瓜视频免费、91视频网站等高清影视资源，
              免费观看电视剧全集和最新电影，无需下载不缓冲，
              即点即播畅享观影。
            </p>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-foreground-800 flex items-center justify-center cursor-pointer hover:bg-primary-500 transition-colors">
                <i className="ri-weibo-line text-background-50 text-sm"></i>
              </div>
              <div className="w-8 h-8 rounded-lg bg-foreground-800 flex items-center justify-center cursor-pointer hover:bg-primary-500 transition-colors">
                <i className="ri-wechat-line text-background-50 text-sm"></i>
              </div>
              <div className="w-8 h-8 rounded-lg bg-foreground-800 flex items-center justify-center cursor-pointer hover:bg-primary-500 transition-colors">
                <i className="ri-bilibili-line text-background-50 text-sm"></i>
              </div>
            </div>
          </div>

          {footerLinks.map((col, i) => (
            <div key={i}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((link, j) => (
                  <li key={j}>
                    <a
                      href={`#${link}`}
                      onClick={(e) => e.preventDefault()}
                      className="text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-foreground-800 pt-8">
          <div className="mb-6">
            <h4 className="text-sm font-semibold text-background-50 mb-3">合作伙伴</h4>
            <div className="flex flex-wrap gap-4">
              <span className="text-xs text-foreground-500">更多合作伙伴即将入驻</span>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} {siteName} 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" onClick={(e) => e.preventDefault()} className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                用户协议
              </a>
              <a href="#" onClick={(e) => e.preventDefault()} className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                隐私政策
              </a>
              <a href="#" onClick={(e) => e.preventDefault()} className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}